<template>
  <div class="flex items-center justify-center w-[250px] aspect-square">
    <NuxtImg
      src="/images/loader-glow.webp"
      alt=""
      densities="x1 x2"
      class="absolute inset-0 shrink-0 animate-spin"
      width="250"
      height="250"
    />
    <SvgoLoaderLogo class="relative shrink-0 w-[63px] h-[73px]" />
  </div>
</template>
